import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import NewsMarquee from "./NewsMarquee";

export default function Navbar() {
  // Removed unused location variable
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOthersOpen, setIsOthersOpen] = useState(false);
  const [isDownloadsOpen, setIsDownloadsOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  // Define navigation structure
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'News', path: '/news' },
    { name: 'RDCA', path: '/about' }, // This will link to the About page
  ];

  // Other links for dropdown
  const otherLinks = [
    { name: 'Tamil Nadu State Chess Association', path: 'https://tamilchess.com/' },
    { name: 'All India Chess Federation', path: 'https://aicf.in/' },
  ];

  // Download links for dropdown
  const downloadLinks = [
    {
      name: "Bid Form",
      path: "/bid-form.pdf",
      type: "download",
    },
    {
      name: "Constitution Form",
      path: "/bid-form.pdf",
      type: "open",
    },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && 
          menuRef.current && 
          !menuRef.current.contains(event.target) &&
          buttonRef.current && 
          !buttonRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
      
      if (!event.target.closest('.dropdown-container')) {
        setIsOthersOpen(false);
        setIsDownloadsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <>
      {/* TOP STRIP */}
      <div 
        className="top-strip w-full h-7"
        style={{ 
          background: '#090f1f' 
        }}
      ></div>

      {/* HEADER */}
      <header className="header relative w-full">
        {/* LOGO BOX - Responsive positioning */}
        <div 
          className="logo-box absolute -top-6 left-4 sm:left-16 md:left-24 w-[80px] h-[100px] sm:w-[111px] sm:h-[140px] flex items-center justify-center z-10"
          style={{ 
           background: 'linear-gradient(180deg, #0A1633,#0E3A8A)',
            boxShadow: '0 4px 15px rgba(0,0,0,0.25)'
          }}
        >
          <img 
            src="/images/image.png" 
            alt="RDCA Logo" 
            className="w-[60px] h-auto sm:w-[100px] object-contain" 
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = "https://ui-avatars.com/api/?name=RDCA&background=d4af37&color=fff&size=48";
            }}
          />
        </div>

        {/* NAVBAR */}
        <nav 
          className="navbar h-[60px] sm:h-[72px] w-full flex items-center px-4 sm:px-12 relative"
          style={{ 
            background: 'linear-gradient(90deg, #0b3a8d, #0e57d1)' 
          }}
        >
          {/* Logo Area - Hidden on mobile, shown on desktop */}
          <div className="hidden sm:block w-[100px] flex-shrink-0"></div>
          
          <h1
            className="
              nav-title text-[#F8FAFC]
              text-base sm:text-2xl md:text-4xl
              font-black font-poppins tracking-wide
              absolute left-1/2 -translate-x-1/2
              sm:static sm:translate-x-0
              text-center
              pointer-events-none
            "
            style={{
              textShadow: '0 2px 10px rgba(0,0,0,0.45)'
            }}
          >
            Ranipet District Chess Academy
          </h1>
        
          {/* Desktop Navigation */}
          <ul className="hidden md:flex gap-7 m-0 p-0 list-none">
            {navLinks.map((link) => (
              <li key={`${link.path}-${link.name}`}>
                <Link 
                  to={link.path}
                  className="text-white text-sm font-medium hover:text-blue-200"
                >
                  {link.name}
                </Link>
              </li>
            ))}
            
            {/* Downloads Dropdown */}
            <li className="relative dropdown-container">
              <button
                onClick={() => setIsDownloadsOpen(!isDownloadsOpen)}
                className="flex items-center gap-1 text-white text-sm font-medium hover:text-blue-200"
              >
                Downloads
                <FaChevronDown
                  size={10}
                  className={`transition-transform ${
                    isDownloadsOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {isDownloadsOpen && (
                <ul className="absolute right-0 top-full mt-2 w-56 bg-white rounded-md shadow-xl z-[9999]">
                  {downloadLinks.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.path}
                        {...(item.type === "download"
                          ? { download: true }
                          : { target: "_blank", rel: "noopener noreferrer" })}
                        className="block px-4 py-3 text-gray-800 hover:bg-blue-50"
                        onClick={() => setIsDownloadsOpen(false)}
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            
            {/* Others Dropdown */}
            {/* Others Dropdown */}
            <li className="relative dropdown-container">
              <button
                onClick={() => setIsOthersOpen(!isOthersOpen)}
                className="flex items-center gap-1 text-white text-sm font-medium hover:text-blue-200"
              >
                Others
                <FaChevronDown
                  size={10}
                  className={`transition-transform ${isOthersOpen ? "rotate-180" : ""}`}
                />
              </button>

              {isOthersOpen && (
                <ul
                  className="
                    absolute right-0 top-full mt-2
                    w-64 bg-white rounded-md
                    shadow-xl z-[9999]
                  "
                >
                  {otherLinks.map((link) => (
                    <li key={link.path}>
                      <a
                        href={link.path}
                        className="block px-4 py-3 text-gray-800 hover:bg-blue-50"
                        onClick={() => setIsOthersOpen(false)}
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          </ul>
                
          {/* Mobile Menu Button */}
          <button 
            ref={buttonRef}
            onClick={toggleMenu}
            className="md:hidden text-white p-2 ml-auto z-50"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </nav>
              
        {/* NEWS MARQUEE STRIP */}
        <div
          className="marquee-wrapper w-full h-10 flex items-center overflow-hidden bg-[#0A1633] pl-4 sm:pl-[120px] pr-4 sm:pr-12"
          style={{
            background: 'linear-gradient(90deg, #0A1633, #0A1633)',
          }}
        >
          <NewsMarquee />
        </div>
              
        {/* Mobile Dropdown Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-[#0A1633] z-50 shadow-xl">
            <ul className="flex flex-col divide-y divide-blue-900">
              {navLinks.map((link) => (
                <li key={`mobile-${link.path}-${link.name}`}>
                  <Link
                    to={link.path}
                    onClick={() => setIsMenuOpen(false)}
                    className="block px-6 py-4 text-white text-base font-medium hover:bg-blue-900"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
                    
              {/* Mobile Downloads Section */}
              <li className="divide-y divide-blue-900">
                <details className="group">
                  <summary className="flex items-center justify-between px-6 py-4 text-white text-base font-medium hover:bg-blue-900 cursor-pointer">
                    <span>Downloads</span>
                    <FaChevronDown size={12} />
                  </summary>

                  <div className="bg-blue-800">
                    {downloadLinks.map((item) => (
                      <a
                        key={item.name}
                        href={item.path}
                        {...(item.type === "download"
                          ? { download: true }
                          : { target: "_blank", rel: "noopener noreferrer" })}
                        className="block px-8 py-3 text-gray-200 hover:bg-blue-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </details>
              </li>
                          
              {/* Mobile Others Section */}
              <li className="divide-y divide-blue-900">
                <details className="group">
                  <summary className="flex items-center justify-between px-6 py-4 text-white text-base font-medium hover:bg-blue-900 cursor-pointer">
                    <span>Others</span>
                    <FaChevronDown size={12} />
                  </summary>
                  <div className="bg-blue-800">
                    {otherLinks.map((link) => (
                      <a
                        key={link.path}
                        href={link.path}
                        className="block px-8 py-3 text-gray-200 hover:bg-blue-700"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {link.name}
                      </a>
                    ))}
                  </div>
                </details>
              </li>
            </ul>
          </div>
        )}
      </header>
    </>
  );
}